import { render } from "./ClientCategory.vue?vue&type=template&id=b1931c6e&scoped=true"
import script from "./ClientCategory.vue?vue&type=script&lang=js"
export * from "./ClientCategory.vue?vue&type=script&lang=js"

import "./ClientCategory.vue?vue&type=style&index=0&id=b1931c6e&lang=scss&scoped=true"

import exportComponent from "C:\\development\\AdmicomWeb\\AdmicomWeb.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1931c6e"]])

export default __exports__